import $ from 'jquery'
import 'slick-carousel'

export default class Carousel {
  constructor() {
    this.config = {
      el: '.js-carousel',
      slider: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false
      }
    }

    this.init()
  }

  init() {
    $(this.config.el).slick(this.config.slider)
  }
}
